<template>
  <div class="admin__home">
    <Header />
    <div class="admin__home--left-div">
      <Sidebar :item="item" />
    </div>
    <div class="admin__home--right-div">
      <div class="message">
        <div class="message__header">
          <div class="message__header--text">Contact Your Account Officer</div>
        </div>
        <div class="message__body">
          <div class="message__body--cards">
            <div>
              <div class="message__body--cards-avatar">
                <div>
                  <img src="./../../../assets/images/boy.svg" alt />
                </div>
              </div>
              <div class="message__body--cards-details">
                <h5>Sam Idowu</h5>
                <p>BSc HRM, CIPM Associate</p>
                <p>
                  <span>(Payroll Officer)</span>
                </p>
                <span>
                  <font-awesome-icon icon="mobile-alt" />&nbsp;0809 325 6398
                </span>
              </div>
              <div class="message__body--cards-label">
                <font-awesome-icon icon="check" />&nbsp;Unlocked
              </div>
            </div>
            <div>
              <div class="message__body--cards-avatar">
                <div>
                  <img src="./../../../assets/images/boy.svg" alt />
                </div>
              </div>
              <div class="message__body--cards-details">
                <h5>Sam Idowu</h5>
                <p>BSc HRM, CIPM Associate</p>
                <p>
                  <span>(Payroll Officer)</span>
                </p>
                <span>
                  <font-awesome-icon icon="mobile-alt" />&nbsp;0809 325 6398
                </span>
              </div>
              <div class="message__body--cards-label">
                <font-awesome-icon icon="check" />&nbsp;Unlocked
              </div>
            </div>
            <div>
              <div class="message__body--cards-avatar">
                <div>
                  <img src="./../../../assets/images/boy.svg" alt />
                </div>
              </div>
              <div class="message__body--cards-details">
                <h5>Sam Idowu</h5>
                <p>BSc HRM, CIPM Associate</p>
                <p>
                  <span>(Payroll Officer)</span>
                </p>
                <span>
                  <font-awesome-icon icon="mobile-alt" />&nbsp;0809 325 6398
                </span>
              </div>
              <div class="message__body--cards-label">
                <font-awesome-icon icon="check" />&nbsp;Unlocked
              </div>
            </div>
          </div>
          <div class="message__body--route">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";

export default {
  name: "Message",
  components: {
    Header,
    Sidebar
  },
  data() {
    return { item: "message" };
  }
};
</script>
<style lang="scss" scoped>
.message {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;
  padding-bottom: 100px;

  .message__header {
    overflow: hidden;
    padding-bottom: 5px;

    > .message__header--text {
      width: 500px;
      float: left;
      font-size: 2.083vw;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      margin: 0;
    }
  }

  > .message__body {
    border-top: 1px solid #caced5;
    padding: 50px 5px 0 5px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: space-between;
    align-content: center;

    > .message__body--cards {
      width: 24.167vw;

      > div {
        border-radius: 5px;
        box-shadow: 0 1px 3px 0 rgba(217, 217, 217, 0.98);
        position: relative;
        background-color: #ffffff;
        margin-bottom: 20px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;

        > .message__body--cards-avatar {
          width: 70px;

          > div {
            width: 40px;
            height: 40px;
            margin: auto;
            border-radius: 60px;
            overflow: hidden;
            text-align: center;

            > img {
              width: 30px;
            }
          }
        }

        > .message__body--cards-details {
          width: calc(100% - 70px);

          > h5 {
            font-size: 1.25vw;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.67;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            height: 30px;
          }

          > p {
            font-size: 0.729vw;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: 2.86;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            margin: 0;
            padding: 0;
            height: 30px;
            > span {
              font-size: 0.729vw;
              font-weight: 500;
              font-style: normal;
              font-stretch: normal;
              line-height: 2.86;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
            }
          }

          > span {
            font-size: 0.729vw;
            font-weight: 300;
            font-style: normal;
            font-stretch: normal;
            line-height: 2.86;
            letter-spacing: normal;
            text-align: left;
            color: #5099de;
          }
        }

        > .message__body--cards-label {
          width: 83px;
          height: 25px;
          background-color: #1ec4b4;
          position: absolute;
          top: 0;
          right: 0;
          font-size: 0.625vw;
          font-weight: 500;
          font-style: normal;
          font-stretch: normal;
          line-height: 3.33;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
        }
      }
    }

    > .message__body--route {
      width: 42.031vw;
    }
  }
}
</style>

